<template>
    <div
        :style="componentStyles"
        class="o-poster-schedule"
    >
        <div class="o-poster-schedule__header">
            <div class="o-poster-schedule__header-title">
                {{$t('ui.departures')}}
            </div>
            <div 
                class="o-poster-schedule__header-date"
                v-html="formattedDate"
            />
        </div>
        <div class="o-poster-schedule__table-wrapper">
            <div class="o-poster-schedule__column-names">
                <div class="o-poster-schedule__column-name o-poster-schedule__column-name--destiantion">
                    {{$t('ui.schedule-destination')}}
                </div>
                <div class="o-poster-schedule__column-name o-poster-schedule__column-name--time">
                    {{$t('ui.schedule-time')}}
                </div>
                <div class="o-poster-schedule__column-name o-poster-schedule__column-name--line">
                    {{$t('ui.schedule-line')}}
                </div>
                <div class="o-poster-schedule__column-name o-poster-schedule__column-name--departs">
                    {{$t('ui.schedule-departs')}}
                </div>
            </div>
            <div class="o-poster-schedule__table">
                <div 
                    class="o-poster-schedule__table-item"
                    v-for="(transport, i) in normalizeSchedule"
                    :key="transport.time+ 'i' + i"
                >
                    <div class="o-poster-schedule__table-item-column o-poster-schedule__item-column--destiantion">
                        {{transport.destination}}
                    </div>
                    <div class="o-poster-schedule__table-item-column o-poster-schedule__item-column--time">
                        {{transport.time}}
                    </div>
                    <div class="o-poster-schedule__table-item-icon">
                        <img :src="transport.icon" alt="transport icon">
                    </div>
                    <div class="o-poster-schedule__table-item-column o-poster-schedule__item-column--line">
                        {{transport.line}}
                    </div>
                    <div class="o-poster-schedule__table-item-column o-poster-schedule__item-column--departs">
                        {{ transport.formatedDeparts}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { TRANSPORT_API_MAP } from "@/utils/services/transport";
import { convertDataStructureToCommon } from "../../../utils/services/resrobot-service";

export default {
    name: "OPosterSchedule",
    data() {
        return {
            currentDate: new Date(),
            dateTimeout: null,
            schedule: [],
            lastSync: '',
            normalizeSchedule: [],
            scheduleTimeout: null,
            manualyChangeScheduleTimeout: null,
            manualyChangeNumber: 0
        };
    },
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp',
            'getObjectsByCategory',
            'getServiceCategories'
        ]),
        componentStyles() {
            return this.getMapConfigProp(`components.OPosterSchedule.styles`) || null;
        },
        componentParams() {
            return this.getMapConfigProp(`components.OPosterSchedule.params`) || null;
        },
        formattedDate() {
            const date = moment(this.currentDate);
            const formattedDay = this.capitalizeFirstLetter(date.format('dddd'));
            const formattedMonth = this.capitalizeFirstLetter(date.format('MMMM'));

            return `${formattedDay} ${date.format('DD')} ${formattedMonth}&nbsp;<div class="time">${date.format('HH:mm:ss')}</div>`;
        },
        transportObjects() {
            let tObjects = [];
            this.getServiceCategories.forEach(service => {
                if(this.checkTransport(service)) {
                    tObjects = [...tObjects, ...this.getObjectsByCategory(service.id)]
                }
            })
            return tObjects
        },
        getScheduleInterval() {
            return this.componentParams?.get_schedule_interval || 300000
        }
    },
    methods: {
        capitalizeFirstLetter(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        async getTimetables(service) {
            const ruterStopId = this.t(service, 'ruter_stop_id') || null;
            const apiProvider = this.t(service, 'timetables_api_provider') || null;
            
            const transportTypes = this.t(service, 'ruter_transport_types') || null;

            if(!ruterStopId) throw new Error(`Station code is not set for: ${this.t(service, 'name') }`);
            if(!apiProvider) throw new Error(`API provider is not set for: ${this.t(service, 'name') }`);

            if(apiProvider && TRANSPORT_API_MAP[apiProvider]){
                try{
                    if (apiProvider === 'resrobot') {
                        const { Departure } = await TRANSPORT_API_MAP[apiProvider](ruterStopId)
                        this.prepareCommonDataStructure(Departure, transportTypes, service);
                    } else {
                        const data = await TRANSPORT_API_MAP[apiProvider](ruterStopId, transportTypes)
                        this.schedule = [...this.schedule, {data, service}]
                    }
                    this.lastSync = this.$moment() // TO DO CHECK IF NEEDED
                }
                catch(error){
                    throw new Error(`${apiProvider} data is not available: ${error}` )
                }
            }
        },
        prepareCommonDataStructure(data, transportTypes, service) {
            const respData = convertDataStructureToCommon(data, transportTypes)
            this.schedule = [...this.schedule, {data: respData, service}]
        },
        checkTransport(item) {
            return this.t(item, 'is_train')
                || this.t(item, 'is_buss')
                || this.t(item, 'is_airport')
                || this.t(item, 'is_metro')
                || false;
        },
        async getSchedule() {
            this.schedule = [];

            await Promise.all(this.transportObjects.map(async serviceItem => {
                await this.getTimetables(serviceItem)
            }))

            this.prepareSchedule()
        },
        prepareSchedule() {
            let arrayOfTransportItem = []

            this.schedule.forEach(({data, service}) => {
                data.forEach(transport => {
                    transport.trains.forEach(train => {
                        arrayOfTransportItem.push({
                            destination: train.destination,
                            time: train.times[0],
                            icon: service?.files?.icon,
                            line: this.t(service, 'name') + ' ' + train.route,
                            departs: this.timeDifferenceInMinutes(train.times[0]),
                            formatedDeparts: this.getFormatedDeparts(this.timeDifferenceInMinutes(train.times[0]))
                        })
                    })
                })
            })
            // we don't want show transport if departs im minutes < 1 lime 0 min or -1 min
            // but for developers in different timezone add t.departs < -20, because we see empty list 
            arrayOfTransportItem = arrayOfTransportItem.filter(t => t.departs > 1 || t.departs < -20)

            arrayOfTransportItem.sort((a, b) => a.departs > b.departs ? 1 : -1)
        
            this.normalizeSchedule = [];
            this.normalizeSchedule = arrayOfTransportItem.length <= 6 ? arrayOfTransportItem : arrayOfTransportItem.slice(0, 6)
        },
        timeDifferenceInMinutes(time) {
            const format = 'HH:mm:ss';
            const time1Moment = moment(time, format);
            const time2Moment = moment(new Date(), format);

            // Calculate the time difference in milliseconds
            const diffInMilliseconds = time1Moment.diff(time2Moment);

            // Convert the time difference to minutes
            const diffInMinutes = moment.duration(diffInMilliseconds).asMinutes();

            // Round the result to the nearest whole number
            return Math.round(diffInMinutes);
        },
        getFormatedDeparts(minutes) {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;

            if (hours > 0) {
                if(remainingMinutes > 0) {
                    return `${hours}h ${remainingMinutes} min`;
                } else {
                    return `${hours}h`;
                }
            } else {
                return `${minutes} min`;
            }
        },
        manualyChangeSchedule() {
            if(this.manualyChangeNumber) {
                --this.manualyChangeNumber
                this.manualyChangeScheduleTimeout = setTimeout(() => {
                    this.normalizeSchedule = this.normalizeSchedule.map(transport => ({
                        ...transport,
                        departs: this.getNewScheduleTime(transport.departs),
                        formatedDeparts: this.getFormatedDeparts(this.getNewScheduleTime(transport.departs))
                    }))
                    this.manualyChangeSchedule();
                }, 60000)
            }
        },
        getNewScheduleTime(time) {
            if(time < 2 && time > -5) {
                return 1
            } else {
                return time - 1
            }
        }
    },
    created() {
        this.dateTimeout = setInterval(() => {
            this.currentDate = new Date();
        }, 1000)
        this.scheduleTimeout = setInterval(() => {
            this.getSchedule();
            this.manualyChangeNumber = Math.floor(this.getScheduleInterval/60000) - 1;
            this.manualyChangeSchedule();
        }, this.getScheduleInterval)
        this.getSchedule();
        this.manualyChangeNumber = Math.floor(this.getScheduleInterval/60000) - 1;
        this.manualyChangeSchedule();

    },
    beforeDestroy() {
        clearInterval(this.dateTimeout)
        clearInterval(this.scheduleTimeout)
        clearTimeout(this.manualyChangeScheduleTimeout)
    }
}
</script>

<style lang="scss">
@import "theme";
</style>